
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M551-800H280v-80h351l-80 80zM391-640H160v-80h311l-80 80zM231-480H40v-80h271l-80 80zm353 80L480-504 280-304l104 104 200-200zm-47-161l104 104 199-199-104-104-199 199zm-84-28l216 216-229 229q-24 24-56 24t-56-24l-2-2-26 26H100l126-126-2-2q-24-24-24-56t24-56l229-229zm0 0l227-227q24-24 56-24t56 24l104 104q24 24 24 56t-24 56L669-373 453-589z"}})])
          )
        }
      }
    